export const PLACE_LOG_STATE = {
    1: '为新增遗患',
    2: '自我整改上传',
    3: '复查遗患',
    4: '隐患已整改',
    5: '预审通过',
    6: '预审不通过',
    7: '督导整改合格',
    8: '督导整改不合格'
}

export const PLACE_LOG = {
    1: '新增遗患',
    2: '排查场所',
    3: '复查',
    4: '监理核查',
    5: '预审通过',
    6: '预审不通过',
    7: '督导整改合格',
    8: '督导整改不合格',
    10: '修改信息',
    11: '修改场所状态',
    12: '修改场所社区'
}


export const Grade = {
    1: 'A级',
    2: 'B级',
    3: 'C级',
    4: 'D级'
}
